import PageBreadcrumb from "../components/common/PageBreadCrumb";
// import UserMetaCard from "../components/UserProfile/UserMetaCard";
import UserInfoCard from "../components/UserProfile/UserInfoCard";
// import UserAddressCard from "../components/UserProfile/UserAddressCard";
import PageMeta from "../components/common/PageMeta";
import UpdatePassword from "../components/auth/UpdatePassword";
import ChangeEmail from "../components/auth/ChangeEmail";
// import ChangePhoneNo from "../components/auth/ChangePhoneNo";
import ApiKey from "../components/Transactions/Apikey";
import SecretKey from "../components/Transactions/SecretKey";
// import AddWebhookUrl from "../components/Transactions/AddWebhookUrl";
import WebhookModal from "../components/webhooks/modals/WebhookModal";
// import { cache } from "../utils";
// import { User } from "../stores/useUserStore";
// import ChangePinModal from "../components/ui/modal/ChangePinModal";
import PinSettings from "../components/ui/modal/PinSettings";
// import AddPhoneNumber from "../components/auth/AddPhoneNumber";

export default function UserProfiles() {
// const cachedUser = cache.get("USER") as User | null;
  
  return (
    <>
      <PageMeta
        title="Profile Settings"
        description="This is the Profile settings page for our business users "
      />
      <PageBreadcrumb pageTitle="Settings" />
      <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] lg:p-6">
        <h3 className="mb-5 text-lg font-semibold text-gray-800 dark:text-white/90 lg:mb-7">
          Profile
        </h3>
        <div className="space-y-6">
          {/* <UserMetaCard /> */}
          <UserInfoCard />
          {/* <UserAddressCard /> */}
          {/* <ChangeEmail /> */}
          {/* { <AddPhoneNumber /> } */}
          {/* <ChangePhoneNo /> */}
          <UpdatePassword />
          {/* {cachedUser?.hasPin && <ChangePinModal />} */}
          <PinSettings />

          <ApiKey />
          <SecretKey />
          <WebhookModal />
          {/* <AddWebhookUrl /> */}
        </div>
      </div>
    </>
  );
}
